import React from "react"
import Dropzone, { DropEvent, FileRejection } from "react-dropzone"
import { Box, Button, Typography } from "@carrotfertility/carotene-core"
import { AcceptableFileExtensions } from "#/components/views/reimbursements/upload/AcceptableFileExtensions"
import { FormattedMessage } from "react-intl"

// @ts-expect-error TS(7031) FIXME: Binding element 'isDragActive' implicitly has an '... Remove this comment to see the full error message
const NewDropzoneIllustration = ({ isDragActive }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      paddingBlockStart: isDragActive ? (theme) => theme.tokens.spacing.xl : 0,
      paddingBlockEnd: isDragActive ? (theme) => theme.tokens.spacing.xxxl : 0,
      gap: (theme) => theme.spacing(theme.tokens.spacing.md)
    }}
  >
    {isDragActive ? (
      <Typography variant="h5" component="p">
        <FormattedMessage defaultMessage="Drop files to upload" />
      </Typography>
    ) : (
      <>
        <Typography variant="h5" component="p">
          <FormattedMessage defaultMessage="Drag and drop files here" />
        </Typography>
        <Typography variant="body2">
          <FormattedMessage defaultMessage="or" />
        </Typography>
        <Button
          sx={{ inlineSize: "fit-content", alignSelf: "center" }}
          variant="outlined"
          size="medium"
          color="secondary"
        >
          <FormattedMessage defaultMessage="Add files" />
        </Button>
      </>
    )}
  </Box>
)

const UploadDropzoneWithIllustration = ({
  small,
  onDropAccepted,
  onDropRejected
}: {
  small: boolean
  onDropAccepted?: <T extends File>(files: T[], event: DropEvent) => void
  onDropRejected: (fileRejections: FileRejection[], event: DropEvent) => void
}) => {
  return (
    <Dropzone
      multiple
      onDropAccepted={onDropAccepted}
      onDropRejected={onDropRejected}
      accept={AcceptableFileExtensions}
    >
      {({ getRootProps, getInputProps, isDragActive }) => (
        <Box
          sx={(theme) => ({
            backgroundColor: "#eee",
            inlineSize: "100%",
            borderRadius: "0.5rem",
            cursor: "pointer",
            textAlign: "center",
            lineHeight: 1,
            paddingInline: theme.spacing(theme.tokens.spacing.md),
            transition: "all 0.3s cubic-bezier(0.8, 0, 0.2, 1)",
            paddingBlock: small ? theme.spacing(theme.tokens.spacing.lg) : "4rem",
            border: isDragActive
              ? `${theme.tokens.borderWidth.md} solid #e48400`
              : `${theme.tokens.borderWidth.md} solid #ccc`
          })}
          {...getRootProps()}
        >
          {isDragActive ? <Box sx={{ position: "fixed", inset: 0, zIndex: 99999999, opacity: 0 }} /> : ""}
          <input id="upload-files-input" data-testid="upload-files-input-test" {...getInputProps()} />
          <NewDropzoneIllustration isDragActive={isDragActive} />
        </Box>
      )}
    </Dropzone>
  )
}

export { UploadDropzoneWithIllustration }
